"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var React = require("react");

var Utilities_1 = require("../../Utilities");

var PivotItem =
/** @class */
function (_super) {
  tslib_1.__extends(PivotItem, _super);

  function PivotItem(props) {
    var _this = _super.call(this, props) || this;

    _this._warnDeprecations({
      linkText: 'headerText'
    });

    return _this;
  }

  PivotItem.prototype.render = function () {
    return React.createElement("div", tslib_1.__assign({}, Utilities_1.getNativeProps(this.props, Utilities_1.divProperties)), this.props.children);
  };

  return PivotItem;
}(Utilities_1.BaseComponent);

exports.PivotItem = PivotItem;